import { getContext } from '@/context';
import getAuthJsonHeaders from '@/requests/common/getAuthJsonHeaders';

export enum PollStatus {
  Failed = 'FAILED',
  Completed = 'COMPLETED',
}

type ResultMediaType =
  | 'image'
  | 'video'
  | 'audio'
  | 'IMAGE'
  | 'VIDEO'
  | 'AUDIO';

type IResult = {
  type: ResultMediaType;
  driveUid?: string;
  result: {
    url: string;
    metadata?: { width: number; height: number };
    frames?: { first?: string; last?: string };
  };
};

export type PollResponse = {
  response: {
    status: PollStatus;
    output?: { url: string };
    result?: Array<IResult>;
  };
};

const pollRequest = async (url: string): Promise<PollResponse> => {
  const response = await getContext().utils.api.fetch(url, {
    headers: getAuthJsonHeaders(),
  });
  const body = await response.json();
  if (!response.ok) {
    throw new Error(
      `Error: ${response.status} ${body?.message || response.statusText}`
    );
  }
  return body;
};

export default pollRequest;
